/**
 * Sport Utilities
 * Get sport names by slugs
 */

import { elements } from '../core/elements.js';

/**
 * Get sport names by slugs from elements.sportItems
 * @param {string[]} slugs
 * @returns {string[]}
 */
export function getSportNamesBySlugs(slugs) {
  return slugs
    .map((slug) => {
      return (
        elements.sportItems.find((sportItem) => sportItem.slug === slug)
          ?.title || ''
      );
    })
    .filter((title) => title !== '');
}

console.log('📦 Sport utils module loaded');
